import * as apiURL from "../../../../helpers/APIdata/apiURL";

// Staff-authenticated calls for Portal Profile admin. Uses the staff `authUser`
// bearer token (separate from the customer portal token).
const staffToken = () => {
  try {
    return JSON.parse(localStorage.getItem("authUser"))?.token || null;
  } catch (e) {
    return null;
  }
};

export const portalProfileApi = async (endpoint, method = "GET", body = null) => {
  const url = apiURL.ApiURL().API_URL + endpoint;
  const headers = { "Content-Type": "application/json", Accept: "application/json" };
  const token = staffToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  try {
    const res = await fetch(url, {
      method,
      headers,
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    return await res.json();
  } catch (e) {
    return { status: 0, error: e?.message || "Network error" };
  }
};

export const PP_ENDPOINTS = {
  list: "/portalprofile/list",
  create: "/portalprofile/create",
  update: "/portalprofile/update",
  del: (id) => `/portalprofile/delete/${id}`,
  availableFields: "/portalprofile/availablefields",
  brandingGet: "/portalprofile/brandingsettings",
  brandingSet: "/portalprofile/brandingsettings",
};
